import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
export var notify = function (message, type, pos) {
    var toastId = toast(message, {
        rtl: true,
        position: pos,
        autoClose: 8000,
        type: type,
    });
};
